export default __webpack_public_path__ + "static/bt-2196947e3283240d005aa874a005af1d.svg";